import type {
  AuthAudienceTypes,
  AuthenticationConnections,
  OrganizationUserAccessTypes,
  OrganizationUserEntityRelationTypes,
  OrganizationUserLoginStatus,
} from '@generated/graphql';
import type { Languages } from '@onevesthq/ov-enums';
import type { Account } from './account';
import type { NotificationGroup } from './notificationGroup';
import type { Organization } from './organization';
import type { RepCode } from './repCode';
import type { Role } from './role';
import type { User } from './user';

export type OrganizationUserEntity = {
  entity?: User;
  readOnly?: boolean;
  relation?: OrganizationUserEntityRelationTypes;
  role?: Role;
  accounts?: Account[];
};

export type OrganizationUserRepCodeEntity = {
  entity?: User;
  repCodes?: RepCode[];
};

export type DisplayRole = {
  id?: string;
  name?: string;
  order?: number;
};

export type NotificationPreference = {
  enableInApp?: boolean;
  enablePush?: boolean;
  enableEmail?: boolean;
};

export type UserNotificationPreference = {
  notificationGroup: NotificationGroup;
  preferences?: NotificationPreference;
};

export type OrganizationUser = {
  id?: string;
  organization?: Organization;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  avatar?: string;
  language?: Languages;
  authAudience?: AuthAudienceTypes;
  role?: Role;
  auth0invitationId?: string;
  auth0invitationExpiresAt?: Date;
  authConnectionType?: AuthenticationConnections;
  accessType?: OrganizationUserAccessTypes;
  entities?: OrganizationUserEntity[];
  referenceId?: string;
  lastLoggedInAt?: Date;
  mfaEnrollmentId?: string;
  notificationPreferences?: UserNotificationPreference[];
  repCodes?: RepCode[];
  repCodeEntities?: OrganizationUserRepCodeEntity[];
  loginStatus?: OrganizationUserLoginStatus;
  viewFullClientGroup?: boolean;
  displayRole?: DisplayRole | null;
};

export const getOrganizationUserName = (
  organizationUser?: OrganizationUser,
): string =>
  `${organizationUser?.firstName || ''} ${organizationUser?.lastName || ''}`.trimEnd();
